
import { Job } from '@/models/main';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({})
export default class RequestForChangeIndicator extends Vue {
  @Prop({ type: Array, required: true }) private readonly jobsWithRequest4Change: string[];
  @Prop({ type: Array, required: true, default: [] }) private readonly storeJobsWithRequest4Change: Job[];

  private req4changeClick(): void {
    if (this.jobsWithRequest4Change.length >= 1) {
      let jobDateMin = this.storeJobsWithRequest4Change[0].job_date;
      let jobDateMax = this.storeJobsWithRequest4Change[0].job_date;
      this.storeJobsWithRequest4Change.map(job => {
        if (job.job_date < jobDateMin) {
          jobDateMin = job.job_date;
        }
        if (job.job_date > jobDateMax) {
          jobDateMax = job.job_date;
        }
      });
      const query = { job_id: this.jobsWithRequest4Change.toString(), dates: `${jobDateMin},${jobDateMax}` };
      this.$router.push({ path: 'search', query: { ...query } }).catch(() => false);
    }
  }
}
